import { API_PATHS } from "../constants/api-paths";
import { IResponse, request } from "../core/api.client";

interface IDynamicViewsResponse {
  current: {
    pageUrl: string;
    views: number;
  };
  related: {
    pageUrl: string;
    views: number;
  }[];
}

interface IDynamicViewsRequest {
  current: {
    pageUrl: string;
    pageType: string;
    isIncreased: boolean;
  };
  related: {
    pageUrl: string;
    pageType: string;
    isIncreased: boolean;
  }[];
}

export const getDynamicViews = async (
  data: IDynamicViewsRequest
): Promise<IResponse<IDynamicViewsResponse>> => {
  const response = await request<IDynamicViewsResponse>({
    method: "POST",
    url: API_PATHS.dynamicViews,
    data,
  });

  return response;
};
